/**
 * This code was generated by Builder.io.
 */
import React, { useState } from "react";
import styles from "./LoginPage.module.css";
import InputField from "./InputField";
import { useNavigate } from 'react-router-dom';
import CreditUnionSearch from "../CreditUnionSearch/CreditUnionSearch";

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Handle login logic here   
    console.log("Login submitted", { username, password });
    navigate('/CreditUnionSearch'); 

  };

  return (
    <main className={styles.loginContainer}>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/2f010dbcb89ba025fd4b8788e97cddbff240bb37025786420187c0ea165a51fd?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
        className={styles.backgroundImage}
        alt=""
      />
      <form className={styles.loginForm} onSubmit={handleSubmit}>
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/351f37e157e8be250a8ac6fdce957ed53bdbd71e10c992b3eb05c459b3570702?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
          className={styles.logo}
          alt="Company Logo"
        />
        <h1 className={styles.loginTitle}>Account Log In</h1>
        <InputField
          label="User Name"
          type="text"
          id="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <InputField
          label="Password"
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className={styles.submitButton}>
          <button type="submit" className={styles.submitButtonInner}>
            <span className={styles.submitButtonContent}>Sign In</span>
          </button>
        </div>
      </form>
    </main>
  );
};

export default LoginPage;
